









import { Component, Prop, Vue } from 'vue-property-decorator'
import IconEnvelope from '@/components/icons/IconEnvelope.vue'
import IconPhoneRetro from '@/components/icons/IconPhoneRetro.vue'
import IconBilling from '@/components/icons/action/IconBilling.vue'
import IconInformation from '@/components/icons/IconInformation.vue'
import IconTeam from '@/components/icons/IconTeam.vue'
import IconCheckOn from '@/components/icons/IconCheckOn.vue'
import IconChecklist from '@/components/icons/IconChecklist.vue'
import { WidgetAction } from '@/embed/widget/actions'

export interface KVAvatarGoalConfiguration {
    type: string
    label: string
    custom?: string
}

@Component({
    components: {
        IconEnvelope,
        IconPhoneRetro,
        IconBilling,
        IconInformation,
        IconTeam,
        IconCheckOn,
        IconChecklist,
    },
})
export default class AvatarGoal extends Vue {

    @Prop() config!: KVAvatarGoalConfiguration

    get action(): string {
        const actions = {
            email: 'mailto:' + this.config.custom,
            call: 'tel:' + this.config.custom,
            custom: this.config.custom,
            information: this.widgetLink(WidgetAction.INFORMATION),
            agent: this.widgetLink(WidgetAction.AGENT),
            valuation: this.widgetLink(WidgetAction.VALUATION),
            checklist: this.widgetLink(WidgetAction.CHECKLIST),
        }

        return actions[this.config.type]
    }

    get icon(): string {
        const icons = {
            email: 'icon-envelope',
            call: 'icon-phone-retro',
            custom: 'icon-billing',
            information: 'icon-information',
            agent: 'icon-team',
            valuation: 'icon-check-on',
            checklist: 'icon-checklist',
        }

        return icons[this.config.type]
    }

    widgetLink(action: WidgetAction): string {
        return process.env.VUE_APP_KEYVUE_WIDGET_BASEURL + action
    }
}
